import type { IconAsset } from '../Icon.types';

const code = (
  <path
    d='m4 4 12 12M16 4 4 16'
    stroke='currentColor'
    strokeLinecap='round'
    strokeWidth='2'
  ></path>
);

export const close: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
